import _ from 'lodash';
import PathToRegexp from 'path-to-regexp';
import qs from 'qs';

/**
 * 将 params 中的参数拼接到 url 中
 * @param {*} url 接口地址
 * @param {*} params 所需的参数
 */
export function toPath(url, params) {
  const match = PathToRegexp.parse(url);
  const nextParams = { ...params };
  if (_.isNil(url)) {
    throw Error('`url` expect url is not empty');
  }

  if (!_.isString(url)) {
    throw Error('`url` expect a string type');
  }

  let nextUrl = PathToRegexp.compile(url)(params);

  // 将 params 中属于 api 的参数剔除
  match.forEach((item) => {
    if (item instanceof Object && item.name in nextParams) {
      delete nextParams[item.name];
    }
  });

  /**
   * 将剩余的参数添加到 url 上
   */
  if (!_.isEmpty(nextParams)) {
    const paramArray = [];
    Object.keys(nextParams).forEach((key) => {
      if (nextParams[key] === null || nextParams[key] === undefined) {
        return;
      }
      if (Array.isArray(nextParams[key])) {
        nextParams[key].forEach((value) => {
          !_.isNil(value) &&
            paramArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        });
        return;
      }
      paramArray.push(`${encodeURIComponent(key)}=${encodeURIComponent(nextParams[key])}`);
    });
    nextUrl += (nextUrl.indexOf('?') === -1 ? '?' : '&') + paramArray.join('&');
  }

  return nextUrl;
}

/**
 * 获取url单个参数
 * @param {*} name
 */
export function getUrlParams(name) {
  const parse = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return parse[name];
}

/**
 * 将 query object 转换为字符串
 * @param query
 * @returns {string}
 */
export function stringifyQuery(query) {
  return qs.stringify(query);
}

/**
 * 将 queryString 转换为 query object
 * @param search
 * @returns {any}
 */
export function parseQuery(search) {
  return qs.parse(search, { ignoreQueryPrefix: true });
}
